import { getEffectiveTranslations } from './i18n';

function t(lang, key) { return getEffectiveTranslations(lang||'en')[key]||key; }

// BeeLove — Bio Generator
// Generates an authentic bio from 5 answers using smart templates.
// No API needed — swap generateBio() for the API version when credits are ready.

export function getBioQuestions(lang) { return [
  { id:'saturday',    emoji:'☀️', label:t(lang,'bio.q1'),                              placeholder:'e.g. Farmers market, long hike, cooking with friends...' },
  { id:'threewords',  emoji:'🧠', label:'How would your best friend describe you in 3 words?',  placeholder:'e.g. Loyal, spontaneous, loud...' },
  { id:'dealbreaker', emoji:'🚩', label:t(lang,'bio.q2'),       placeholder:'e.g. Honesty, a love of dogs, travel...' },
  { id:'proudof',     emoji:'✨', label:t(lang,'bio.q3'),                  placeholder:'e.g. I learned to cook Thai from scratch...' },
  { id:'looking',     emoji:'💛', label:t(lang,'bio.q4'),      placeholder:'e.g. Someone to adventure with, a real partner...' },
];
}
export const BIO_QUESTIONS = getBioQuestions('en');

// ── Local template generator (no API) ───────────────────────
function buildBioFromTemplate(answers, profile) {
  const { saturday, threewords, dealbreaker, proudof, looking } = answers;
  const name   = profile.name?.split(' ')[0] || 'I';
  const city   = profile.city || '';
  const job    = profile.job  || '';

  // Sentence 1 — who they are
  const openers = [
    `${job ? job + ' by day' : 'Based in ' + city}, my ideal weekend involves ${saturday?.toLowerCase() || 'good food and good company'}.`,
    `My friends would call me ${threewords?.toLowerCase() || 'genuine and curious'} — I think that's about right.`,
    `I spend my weeks as a ${job || 'person with too many projects'} and my weekends ${saturday?.toLowerCase() || 'recharging in my own way'}.`,
  ];

  // Sentence 2 — what makes them them
  const middles = [
    `The one thing I will never compromise on? ${dealbreaker || 'Honesty — always'}.`,
    `Something I do not talk about enough: ${proudof || 'the small wins that got me here'}.`,
    `People who know me well know about ${proudof?.toLowerCase() || 'my stubbornly optimistic outlook'} — and how seriously I take ${dealbreaker?.toLowerCase() || 'the things that matter'}.`,
  ];

  // Sentence 3 — what they are looking for
  const closers = [
    `Right now I am hoping to find ${looking?.toLowerCase() || 'something real and unhurried'}.`,
    `If you are looking for ${looking?.toLowerCase() || 'a genuine connection'}, let us start with coffee and see where it goes.`,
    `Mostly I am after ${looking?.toLowerCase() || 'someone to make the ordinary feel less ordinary'} — if that sounds like you, say hello.`,
  ];

  // Pick one from each bucket pseudo-randomly based on answer lengths
  const pick = (arr, seed) => arr[seed % arr.length];
  const s1 = pick(openers,  (saturday?.length    || 3));
  const s2 = pick(middles,  (proudof?.length     || 5));
  const s3 = pick(closers,  (looking?.length     || 7));

  return `${s1} ${s2} ${s3}`;
}

// ── Main export ──────────────────────────────────────────────
export async function generateBio(answers, profile) {
  try {
    const { generateBioFromAPI } = await import('./api');
    const { bio } = await generateBioFromAPI({ answers, profile });
    if (bio) return bio;
  } catch {
    // Edge Function unavailable or rate-limited — fall through to local template
  }

  await new Promise(r => setTimeout(r, 900));
  return buildBioFromTemplate(answers, profile);
}
